import { getFunctions, httpsCallable } from "firebase/functions";

export async function triggerStripeChargesSync(projectId: string) {
  const functions = getFunctions();
  const syncStripeChargesForProject = httpsCallable(
    functions,
    "syncStripeChargesForProject",
  );

  const result = await syncStripeChargesForProject({ projectId });
  if (
    result.data &&
    typeof result.data === "object" &&
    "message" in result.data
  ) {
    return (result.data as { message: string }).message;
  }

  return null;
}

export async function triggerExpandSyncRange(projectId: string) {
  const functions = getFunctions();
  const expandStripeSyncRange = httpsCallable(
    functions,
    "expandStripeSyncRange",
    { timeout: 540_000 },
  );

  const result = await expandStripeSyncRange({ projectId });
  if (
    result.data &&
    typeof result.data === "object" &&
    "message" in result.data
  ) {
    return (result.data as { message: string }).message;
  }

  return null;
}
